/**
 * Toggle — accessible on/off switch with editorial pastel styling.
 * Big enough for touch (44px+ target).
 *
 * Usage:
 *   <Toggle checked={value} onChange={setValue} label="..." testId="..." />
 */
import { useId } from "react";

export const Toggle = ({
  checked,
  onChange,
  label,
  hint,
  testId,
  disabled = false,
}) => {
  const reactId = useId();
  const id = testId ? `toggle-${testId}` : `toggle-${reactId}`;
  return (
    <div
      className={`flex items-start justify-between gap-4 bg-porcelain rounded-2xl px-4 py-3 border border-sandBeige ${disabled ? "opacity-60" : ""}`}
    >
      <div className="flex flex-col flex-1 min-w-0">
        <label
          htmlFor={id}
          className="text-sm text-cocoa font-medium cursor-pointer select-none leading-snug"
        >
          {label}
        </label>
        {hint && (
          <span className="text-xs text-warmGrey mt-1 leading-relaxed">
            {hint}
          </span>
        )}
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        id={id}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        data-testid={testId}
        className={`relative inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-raspberry/40 focus:ring-offset-2 focus:ring-offset-porcelain ${
          checked ? "bg-raspberry" : "bg-sandBeige"
        }`}
      >
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-soft transition-transform duration-200 ${
            checked ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </button>
    </div>
  );
};

export default Toggle;
